export const YOUTUBE_URL = "https://www.youtube.com/embed/";
